import { MutationTree, ActionTree, ActionContext, GetterTree } from "vuex";
import { RootState } from "@/store";
import { UtilitiesRequests } from "@/helpers";

export interface Dialog {
  type?: string | null;
  state?: boolean;
  childData?: any;
}
export interface AppState {
  snackbarMessage: string;
  snackbarColor: string;
  defaultColor: string;
  dialogManager?: Dialog | Object;
  searchFilters: any;
  paginationObject: any;
  tagsList?: any;
}

export type AuthModeType = "login" | "signup";
type AppContext = ActionContext<AppState, RootState>;

export const namespaced = true;

export const state = (): AppState => ({
  snackbarMessage: "",
  snackbarColor: "",
  defaultColor: "red",
  tagsList: [],
  dialogManager: {
    type: null,
    state: false,
    childData: null // Data managed inside the child component
  },
  searchFilters: {
    queryString: "",
    filtersArray: []
  },
  paginationObject: {
    page: 1,
    rowsPerPage: 9,
    sortBy: null,
    sortType: "ASC"
  }
});

export interface snackbarData {
  message: string;
  color: string;
}

export const getters: GetterTree<AppState, RootState> = {};

export const mutations: MutationTree<AppState> = {
  setSnackbarMessage(state: AppState, data: snackbarData) {
    // state.snackbarMessage +=
    //   state.snackbarMessage === "" ? `${data.message}` : `\n ${data.message}`;
    state.snackbarMessage = data.message;
    state.snackbarColor =
      data.color === undefined ? state.defaultColor : data.color;
  },
  deleteMessage(state: AppState) {
    state.snackbarMessage = "";
  },
  setDialog(state: AppState, dialog: any) {
    state.dialogManager = dialog;
  },
  closeDialog(state: AppState, dialog: any) {
    state.dialogManager = { type: null, state: false, childData: null };
  },
  setSearchFilters(state: AppState, data: any) {
    if (data.queryString || data.queryString === "")
      state.searchFilters.queryString = data.queryString;
    if (data.filtersArray) state.searchFilters.filtersArray = data.filtersArray;
  },
  setPagination(state: AppState, data: any) {
    if (data) {
      if (data.page) state.paginationObject.page = data.page;
      if (data.rowsPerPage)
        state.paginationObject.rowsPerPage = data.rowsPerPage;
      if (data.sortBy) state.paginationObject.sortBy = data.sortBy;
      if (data.sortType) state.paginationObject.sortType = data.sortType;
    } else {
      state.paginationObject = {
        page: 1,
        rowsPerPage: 9,
        sortBy: null,
        sortType: "ASC"
      };
    }
  },
  setTagsList(state: AppState, data: any) {
    state.tagsList = data;
  }
};

export const actions: ActionTree<AppState, RootState> = {
  setSnackbarMessage(context: AppContext, data: snackbarData) {
    context.commit("setSnackbarMessage", data);
  },
  deleteMessage(context: AppContext) {
    context.commit("deleteMessage");
  },
  setDialog(context: AppContext, dialog: any) {
    context.commit("setDialog", dialog);
  },
  closeDialog(context: AppContext) {
    context.commit("closeDialog");
  },
  refreshSearchFilters(context: AppContext, data: any): any {
    context.commit("setSearchFilters", data);
  },
  refreshPagination(context: AppContext, data: any): any {
    context.commit("setPagination", data);
  },
  setTagsList(context: AppContext, data: any): any {
    context.commit("setTagsList", data);
  }
};
